import * as React from "react";
import { SortOrder } from "../interfaces";

// https://heroicons.com/ -> chevron-down
const sortDesc = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m19.5 8.25-7.5 7.5-7.5-7.5"
    />
  </svg>
);

// https://heroicons.com/ -> chevron-up
const sortAsc = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 15.75 7.5-7.5 7.5 7.5"
    />
  </svg>
);

interface SorterParams {
  readonly sortOrder: SortOrder;
  readonly thisField: string;
}
export const Sorter = ({
  sortOrder,
  thisField,
}: SorterParams): React.ReactElement | null => {
  if (sortOrder.field !== thisField) {
    return null;
  }

  return (
    <span className="ml-8 float-right text-slate-400 dark:text-slate-400">
      {sortOrder.reversed ? sortDesc : sortAsc}
    </span>
  );
};
